export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 500,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}
